import apiClient from './client';

export const authApi = {
  /**
   * Login with username and password
   */
  login: async (username, password, totp = null) => {
    const response = await apiClient.post('/api/auth/login', {
      username, // Changed from email to username
      password,
      totp,
    });
    return response.data;
  },

  /**
   * Register a new user
   */
  register: async (username, password, name) => {
    const response = await apiClient.post('/api/auth/register', {
      username, // Changed from email to username
      password,
      name,
    });
    return response.data;
  },

  /**
   * Refresh access token
   */
  refreshToken: async () => {
    const response = await apiClient.post('/api/auth/refresh');
    return response.data;
  },

  /**
   * Logout user
   */
  logout: async () => {
    const response = await apiClient.post('/api/auth/logout');
    return response.data;
  },

  /**
   * Start 2FA setup (returns QR code and secret)
   */
  startTwoFactorSetup: async () => {
    const response = await apiClient.post('/api/auth/2fa/setup');
    return response.data;
  },

  /**
   * Verify 2FA code and enable 2FA
   */
  verifyTwoFactor: async (token) => {
    const response = await apiClient.post('/api/auth/2fa/verify', { token });
    return response.data;
  },

  /**
   * Disable 2FA
   */
  disableTwoFactor: async () => {
    const response = await apiClient.post('/api/auth/2fa/disable');
    return response.data;
  },

  getPreferences: async () => {
    const response = await apiClient.get('/api/auth/preferences');
    return response.data;
  },

  savePreferences: async (preferences) => {
    const response = await apiClient.put('/api/auth/preferences', preferences);
    return response.data;
  },
};

